import firebase from 'firebase';
import moment from 'moment'
import store from './store'

/**
 * Envia un log al servidor
 * @param {string} param.tipo - Tipo de log a registrar. Ej.: Desconexion, Error
 * @param {any} [param.excepcion] - Excepcion generada
 * @param {string} [param.informacionextra] - Valores de variables o parametros que podrian haber generado la excepcion
 * @param {string} [param.fecha=new Date()] - fecha y hora del log
 */
export const sendLog = async ({tipo, informacion_extra } = {}) =>{
    try {

        const empresa = store.getState().empresa;
        const aplicacion = (empresa=='pena')? 'pena_web': 'bacer_web' ; 
        const usuario = firebase.auth().currentUser.uid;
        const fecha      = moment().format('YYYY/MM/DD');
    
        const log = {
            aplicacion,
            fecha,
            timestamp:firebase.database.ServerValue.TIMESTAMP,
            tipo,
            usuario,
            informacion_extra: informacion_extra || null,
        };
        firebase.database().ref().child('logs').push(log);
        
    } catch (error) {
        console.log('error :', error);
    }
}




// WEBPACK FOOTER //
// ./src/util.js